import { useMutation, useQuery } from "react-query";
import http from "shared/http";
import { GridFetchResponse } from "shared/types";

export interface AuditLogEntry {
  eventType: string;
  message: string;
  userName: string | null;
  timeStamp: string;
}

export interface AdminDashboardStats {
  activeUsers: number;
  pendingApprovals: number;
  todayAuditEventCount: number;
  recentActivity: AuditLogEntry[];
}

export const useAdminDashboardStatsQuery = () => {
  return useQuery(
    ["adminDashboardStats"],
    async (): Promise<AdminDashboardStats> => {
      return await http.fetchAsync("admin/dashboard/stats");
    },
    {
      staleTime: 2 * 60 * 1000, // 2 minutes
    },
  );
};

export interface UseGetAuditLogsForGridQueryOptions {
  eventType?: string;
  level?: string;
  userName?: string;
  message?: string;
  dateFrom?: string | null;
  dateTo?: string | null;
  take?: number;
  skip?: number;
  sortBy?: string;
  ascending?: boolean;
}

export const useGetAuditLogsForGridQuery = (
  params: UseGetAuditLogsForGridQueryOptions,
) => {
  return useQuery(
    ["audit-logs-grid", JSON.stringify(params)],
    async (): Promise<GridFetchResponse> => {
      return await http.fetchAsync("admin/audit-logs/search", params);
    },
    {
      staleTime: 30 * 1000,
      enabled: true,
    },
  );
};

export interface SendTestEmailPayload {
  emailType: string;
  toEmail: string;
}

export const useSendTestEmailMutation = () => {
  return useMutation((payload: SendTestEmailPayload) =>
    http.postAsync("admin/tests/send-email", payload),
  );
};
